__turbopack_context__.v({
  "buttonsWrapper": "_99CmVW_buttonsWrapper",
  "container": "_99CmVW_container",
  "content": "_99CmVW_content",
  "description": "_99CmVW_description",
  "title": "_99CmVW_title",
});
